// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-notes-container {
  padding: 0rem !important;
  min-height: auto;
}
.modal-notes-container .modal-notes-form-wrapper {
  width: 100% !important;
}

.notes-container {
  background: var(--grey-shade-three);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
@media (max-width: 768px) {
  .notes-container {
    padding: 1rem;
  }
}
.notes-container .note-form-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  z-index: 1001;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.notes-container .note-form-close-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.notes-container .note-form-close-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.notes-form-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: notes-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .notes-form-wrapper {
    padding: 1rem;
    width: 100%;
  }
}
.notes-form-wrapper .notes-title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  text-align: center;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .notes-form-wrapper .notes-title {
    font-size: 1.25rem;
  }
}
.notes-form-wrapper .modal-notes-title {
  font-size: 1.3rem;
}
.notes-form-wrapper .notes-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}

.notes-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
@media (max-width: 768px) {
  .notes-form {
    gap: 1rem;
  }
}
.notes-form .form-section:last-of-type {
  margin-bottom: 0;
}
.notes-form .form-section h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.notes-form .notes-form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5rem;
}
.notes-form .notes-form-group:last-child {
  margin-bottom: 0;
}
.notes-form .notes-form-group .notes-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.notes-form .notes-form-group .notes-label .notes-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.notes-form .notes-form-group .notes-input,
.notes-form .notes-form-group .custom-dropdown-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.notes-form .notes-form-group .notes-input:focus,
.notes-form .notes-form-group .custom-dropdown-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.notes-form .notes-form-group .notes-input::placeholder,
.notes-form .notes-form-group .custom-dropdown-input::placeholder {
  color: #9ca3af;
}
.notes-form .notes-form-group .notes-input:disabled,
.notes-form .notes-form-group .custom-dropdown-input:disabled {
  background-color: #e9ecef;
  color: #6b7280;
  cursor: not-allowed;
}
.notes-form .notes-form-group select.notes-input {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.notes-form .case-selector .clear-case-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #6b7280;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  z-index: 1;
}
.notes-form .case-selector .clear-case-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.notes-form .case-selector .clear-case-button:active {
  background-color: #e5e7eb;
}
.notes-form .notes-form-group .notes-textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  min-height: 200px;
  resize: vertical;
}
.notes-form .notes-form-group .notes-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.notes-form .notes-form-group .notes-textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.notes-form .notes-form-group .notes-textarea::placeholder {
  color: #9ca3af;
}
.notes-form .notes-form-group .notes-textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.notes-form .notes-form-group .case-selector {
  position: relative;
}
.notes-form .notes-form-group .case-selector .dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  z-index: 1000;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  margin-top: 0.25rem;
  overflow: hidden;
  animation: dropdown-fade-in 0.2s ease-out;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-tabs {
  display: flex;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-tabs button {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-tabs button:hover {
  background: #f3f4f6;
  color: #374151;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-tabs button.active {
  background: #ffffff;
  color: #3b82f6;
  font-weight: 600;
  border-bottom-color: #3b82f6;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options {
  max-height: 250px;
  overflow-y: auto;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .dropdown-option {
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .dropdown-option:hover {
  background: #f9fafb;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .dropdown-option.selected {
  background: #eff6ff;
  color: #1e40af;
  border-left: 3px solid #3b82f6;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .dropdown-option.selected .case-parties {
  font-weight: 600;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-parties {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
  line-height: 1.4;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-ref {
  font-size: 0.75rem;
  color: #6b7280;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace;
  background: #f3f4f6;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  display: inline-block;
  margin-bottom: 0.25rem;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-number {
  font-size: 0.75rem;
  color: #9ca3af;
}
.notes-form .notes-form-group .case-selector .dropdown-content .dropdown-options .no-data {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.notes-form .notes-form-group .case-selector .dropdown-content .loading-state,
.notes-form .notes-form-group .case-selector .dropdown-content .no-results,
.notes-form .notes-form-group .case-selector .dropdown-content .empty-state {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.notes-form .notes-form-group .case-selector .dropdown-content .loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.notes-form .notes-form-group .case-selector .dropdown-content .loading-state::before {
  content: "";
  width: 16px;
  height: 16px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.notes-actions {
  display: flex;
  justify-content: end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .notes-actions {
    flex-direction: column;
  }
}
.notes-actions .notes-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .notes-actions .notes-btn {
    width: 100%;
  }
}
.notes-actions .notes-btn.notes-btn-save {
  background-color: var(--primary-color);
  color: white;
}
.notes-actions .notes-btn.notes-btn-save:focus {
  outline: none;
}
.notes-actions .notes-btn.notes-btn-save:hover {
  background-color: #005a9a;
}
.notes-actions .notes-btn.notes-btn-save:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.notes-actions .notes-btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.notes-actions .notes-btn-cancel:hover {
  background-color: #f8f9fa;
}

@keyframes notes-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.dropdown-options::-webkit-scrollbar {
  width: 6px;
}

.dropdown-options::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.dropdown-options::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 768px) {
  .notes-form {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .notes-container {
    padding: 0.5rem;
  }
  .notes-form-wrapper {
    padding: 0.75rem;
  }
  .notes-title {
    font-size: 1.125rem;
  }
  .notes-form-group .notes-input,
  .notes-form-group .notes-textarea,
  .notes-form-group .custom-dropdown-input {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .notes-actions .notes-btn {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
}
@media print {
  .notes-container {
    background: white;
    padding: 0;
  }
  .notes-form-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .notes-actions,
  .dropdown-content {
    display: none;
  }
  .note-form-close-button {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/forms/NoteForm/NoteForm.scss"],"names":[],"mappings":"AACA;EACE,wBAAA;EACA,gBAAA;AAAF;AAGE;EACE,sBAAA;AADJ;;AAMA;EACE,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAHF;AAME;EAVF;IAWI,aAAA;EAHF;AACF;AAOE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AALJ;AAQI;EACE,yBAAA;EACA,cAAA;AANN;AAUI;EACE,aAAA;EACA,6CAAA;AARN;;AAeA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,2CAAA;EACA,UAAA;AAZF;AAeE;EAVF;IAWI,aAAA;IACA,WAAA;EAZF;AACF;AAgBE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AAdJ;AAiBI;EARF;IASI,kBAAA;EAdJ;AACF;AAkBE;EACE,iBAAA;AAhBJ;AAqBE;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAnBJ;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAtBF;AAyBE;EANF;IAOI,SAAA;EAtBF;AACF;AA8BI;EACE,gBAAA;AA5BN;AAgCI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AA9BN;AAoCE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AAlCJ;AAqCI;EACE,gBAAA;AAnCN;AAwCI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAtCN;AAyCM;EACE,cAAA;EACA,oBAAA;AAvCR;AA6CI;;EAEE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AA3CN;AA8CM;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA3CR;AAoDM;;EACE,cAAA;AAjDR;AAoDM;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAjDR;AAsDI;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AApDN;AA0DI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AAxDN;AA0DM;EACE,yBAAA;EACA,cAAA;AAxDR;AA2DM;EACE,yBAAA;AAzDR;AA+DI;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AA7DN;AAgEM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA9DR;AAkEM;EACE,qBAAA;AAhER;AAoEM;EACE,cAAA;AAlER;AAsEM;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AApER;AA0EI;EACE,kBAAA;AAxEN;AA4EM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,qFAAA;EAEA,mBAAA;EACA,gBAAA;EACA,yCAAA;AA3ER;AA8EQ;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AA5EV;AA+EU;EACE,SAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;AA7EZ;AAgFY;EACE,mBAAA;EACA,cAAA;AA9Ed;AAkFY;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;AAhFd;AAsFQ;EACE,iBAAA;EACA,gBAAA;AApFV;AAuFU;EACE,qBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AArFZ;AAwFY;EACE,mBAAA;AAtFd;AA0FY;EACE,mBAAA;EACA,cAAA;EACA,8BAAA;AAxFd;AA2Fc;EACE,gBAAA;AAzFhB;AA+Fc;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AA7FhB;AAiGc;EACE,kBAAA;EACA,cAAA;EACA,mGAAA;EAEA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;AAhGhB;AAoGc;EACE,kBAAA;EACA,cAAA;AAlGhB;AAwGU;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAtGZ;AA4GM;;;EAGE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AA1GR;AA8GM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AA5GR;AA+GQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AA7GV;;AAuHA;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AApHF;AAuHE;EARF;IASI,sBAAA;EApHF;AACF;AAuHE;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AArHJ;AAwHI;EAXF;IAYI,WAAA;EArHJ;AACF;AAwHI;EACE,sCAAA;EACA,YAAA;AAtHN;AAyHM;EACE,aAAA;AAvHR;AAyHM;EACE,yBAAA;AAvHR;AA2HM;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AAzHR;AA8HE;EACI,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AA5HN;AA+HM;EACE,yBAAA;AA7HR;;AAsIA;EACE;IACE,UAAA;IACA,2BAAA;EAnIF;EAuIA;IACE,UAAA;IACA,wBAAA;EArIF;AACF;AAyIA;EACE;IACE,UAAA;IACA,2BAAA;EAvIF;EA2IA;IACE,UAAA;IACA,wBAAA;EAzIF;AACF;AA8IA;EACE,UAAA;AA5IF;;AAgJA;EACE,mBAAA;EACA,kBAAA;AA7IF;;AAiJA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EAAA,sCAAA;AA9IF;;AAkJA;EACE,mBAAA;AA/IF;;AAoJA;EACE;IACE,WAAA;EAjJF;AACF;AAqJA;EACE;IACE,eAAA;EAnJF;EAuJA;IACE,gBAAA;EArJF;EAyJA;IACE,mBAAA;EAvJF;EA4JE;;;IAGE,iBAAA;IACA,oBAAA;EA1JJ;EAgKE;IACE,oBAAA;IACA,oBAAA;EA9JJ;AACF;AAoKA;EACE;IACE,iBAAA;IACA,UAAA;EAlKF;EAsKA;IACE,gBAAA;IACA,sBAAA;EApKF;EAwKA;;IAEE,aAAA;EAtKF;EA0KA;IACE,aAAA;EAxKF;AACF","sourcesContent":["// Main Container - Match ExpenseForm\r\n.modal-notes-container {\r\n  padding: 0rem !important;\r\n  min-height: auto;\r\n\r\n\r\n  .modal-notes-form-wrapper {\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n\r\n.notes-container {\r\n  background: var(--grey-shade-three);\r\n  padding: 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: relative;\r\n\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n  }\r\n\r\n\r\n  // Close button for modal\r\n  .note-form-close-button {\r\n    position: absolute;\r\n    top: 1rem;\r\n    right: 1rem;\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.5rem;\r\n    color: #6b7280;\r\n    cursor: pointer;\r\n    z-index: 1001;\r\n    width: 2rem;\r\n    height: 2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 0.25rem;\r\n    transition: all 0.2s ease;\r\n\r\n\r\n    &:hover {\r\n      background-color: #f3f4f6;\r\n      color: #374151;\r\n    }\r\n\r\n\r\n    &:focus {\r\n      outline: none;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Form Wrapper - Match ExpenseForm wrapper structure\r\n.notes-form-wrapper {\r\n  background: #ffffff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  animation: notes-form-fade-in 0.3s ease-out;\r\n  width: 70%;\r\n\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n    width: 100%;\r\n  }\r\n\r\n\r\n  // Title styling\r\n  .notes-title {\r\n    font-size: 1.3rem;\r\n    font-weight: 500;\r\n    color: #374151;\r\n    text-align: center;\r\n    margin-bottom: 0.5rem;\r\n\r\n\r\n    @media (max-width: 768px) {\r\n      font-size: 1.25rem;\r\n    }\r\n  }\r\n\r\n\r\n  .modal-notes-title {\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n\r\n  // Divider styling\r\n  .notes-divider {\r\n    border: none;\r\n    border-top: 1px solid #e5e7eb;\r\n    margin: 1.5rem 0;\r\n  }\r\n}\r\n\r\n\r\n// Form Content\r\n.notes-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n\r\n\r\n  @media (max-width: 768px) {\r\n    gap: 1rem;\r\n  }\r\n\r\n\r\n  // Form sections - Match ExpenseForm structure\r\n  .form-section {\r\n    // margin-bottom: 1.5rem;\r\n\r\n\r\n    &:last-of-type {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n\r\n    h3 {\r\n      font-size: 1rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin: 0 0 1rem 0;\r\n      padding-bottom: 0.5rem;\r\n      border-bottom: 1px solid #e5e7eb;\r\n    }\r\n  }\r\n\r\n\r\n  // Form Groups\r\n  .notes-form-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-bottom: 0.5rem;\r\n\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n\r\n    // Label styling\r\n    .notes-label {\r\n      display: block;\r\n      margin-bottom: 0.5rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      color: #374151;\r\n\r\n\r\n      .notes-required {\r\n        color: #ef4444;\r\n        margin-left: 0.25rem;\r\n      }\r\n    }\r\n\r\n\r\n    // Input styling to match ExpenseForm\r\n    .notes-input,\r\n    .custom-dropdown-input {\r\n      width: 100%;\r\n      padding: 0.5rem;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-family: inherit;\r\n      color: #374151;\r\n      background: #ffffff;\r\n      box-sizing: border-box;\r\n      height: 2.5rem;\r\n\r\n\r\n      &:focus {\r\n        outline: none;\r\n        border-color: #3b82f6;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n\r\n\r\n      // &:hover:not(:focus) {\r\n      //   border-color: #9ca3af;\r\n      // }\r\n\r\n\r\n      &::placeholder {\r\n        color: #9ca3af;\r\n      }\r\n\r\n      &:disabled {\r\n        background-color: #e9ecef;\r\n        color: #6b7280;\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n\r\n    // Select styling\r\n    select.notes-input {\r\n      appearance: none;\r\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n      background-position: right 0.5rem center;\r\n      background-repeat: no-repeat;\r\n      background-size: 1.5rem 1.5rem;\r\n      padding-right: 2.5rem;\r\n    }\r\n  }\r\n\r\n  // Case selector clear button\r\n  .case-selector {\r\n    .clear-case-button {\r\n      position: absolute;\r\n      right: 10px;\r\n      top: 50%;\r\n      transform: translateY(-50%);\r\n      background: transparent;\r\n      border: none;\r\n      color: #6b7280;\r\n      font-size: 24px;\r\n      cursor: pointer;\r\n      padding: 0;\r\n      width: 24px;\r\n      height: 24px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      border-radius: 50%;\r\n      transition: all 0.2s ease;\r\n      z-index: 1;\r\n\r\n      &:hover {\r\n        background-color: #f3f4f6;\r\n        color: #374151;\r\n      }\r\n\r\n      &:active {\r\n        background-color: #e5e7eb;\r\n      }\r\n    }\r\n  }\r\n\r\n  .notes-form-group {\r\n    .notes-textarea {\r\n      width: 100%;\r\n      padding: 0.5rem;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-family: inherit;\r\n      color: #374151;\r\n      background: #ffffff;\r\n      box-sizing: border-box;\r\n      min-height: 200px;\r\n      resize: vertical;\r\n\r\n\r\n      &:focus {\r\n        outline: none;\r\n        border-color: #3b82f6;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n\r\n\r\n      &:hover:not(:focus) {\r\n        border-color: #9ca3af;\r\n      }\r\n\r\n\r\n      &::placeholder {\r\n        color: #9ca3af;\r\n      }\r\n\r\n\r\n      &:disabled {\r\n        background-color: #f9fafb;\r\n        color: #6b7280;\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n\r\n\r\n    // Case Selector - Match ExpenseForm exactly\r\n    .case-selector {\r\n      position: relative;\r\n\r\n\r\n      // Dropdown content\r\n      .dropdown-content {\r\n        position: absolute;\r\n        top: 100%;\r\n        left: 0;\r\n        width: 100%;\r\n        background: #ffffff;\r\n        border: 1px solid #d1d5db;\r\n        border-radius: 0.375rem;\r\n        z-index: 1000;\r\n        box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),\r\n          0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n        margin-top: 0.25rem;\r\n        overflow: hidden;\r\n        animation: dropdown-fade-in 0.2s ease-out;\r\n\r\n\r\n        .dropdown-tabs {\r\n          display: flex;\r\n          background: #f9fafb;\r\n          border-bottom: 1px solid #e5e7eb;\r\n\r\n\r\n          button {\r\n            flex: 1;\r\n            padding: 0.75rem 1rem;\r\n            border: none;\r\n            background: transparent;\r\n            color: #6b7280;\r\n            font-weight: 500;\r\n            font-size: 0.875rem;\r\n            cursor: pointer;\r\n            transition: all 0.2s ease;\r\n            border-bottom: 2px solid transparent;\r\n\r\n\r\n            &:hover {\r\n              background: #f3f4f6;\r\n              color: #374151;\r\n            }\r\n\r\n\r\n            &.active {\r\n              background: #ffffff;\r\n              color: #3b82f6;\r\n              font-weight: 600;\r\n              border-bottom-color: #3b82f6;\r\n            }\r\n          }\r\n        }\r\n\r\n\r\n        .dropdown-options {\r\n          max-height: 250px;\r\n          overflow-y: auto;\r\n\r\n\r\n          .dropdown-option {\r\n            padding: 0.75rem 1rem;\r\n            cursor: pointer;\r\n            border-bottom: 1px solid #f3f4f6;\r\n            transition: all 0.2s ease;\r\n\r\n\r\n            &:hover {\r\n              background: #f9fafb;\r\n            }\r\n\r\n\r\n            &.selected {\r\n              background: #eff6ff;\r\n              color: #1e40af;\r\n              border-left: 3px solid #3b82f6;\r\n\r\n\r\n              .case-parties {\r\n                font-weight: 600;\r\n              }\r\n            }\r\n\r\n\r\n            .case-info {\r\n              .case-parties {\r\n                font-weight: 500;\r\n                color: #374151;\r\n                font-size: 0.875rem;\r\n                margin-bottom: 0.25rem;\r\n                line-height: 1.4;\r\n              }\r\n\r\n\r\n              .case-ref {\r\n                font-size: 0.75rem;\r\n                color: #6b7280;\r\n                font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Consolas,\r\n                  \"Liberation Mono\", Menlo, monospace;\r\n                background: #f3f4f6;\r\n                padding: 0.125rem 0.375rem;\r\n                border-radius: 0.25rem;\r\n                display: inline-block;\r\n                margin-bottom: 0.25rem;\r\n              }\r\n\r\n\r\n              .case-number {\r\n                font-size: 0.75rem;\r\n                color: #9ca3af;\r\n              }\r\n            }\r\n          }\r\n\r\n\r\n          .no-data {\r\n            padding: 2rem 1rem;\r\n            text-align: center;\r\n            color: #6b7280;\r\n            font-style: italic;\r\n            font-size: 0.875rem;\r\n          }\r\n        }\r\n\r\n\r\n       \r\n      .loading-state,\r\n      .no-results,\r\n      .empty-state {\r\n        padding: 2rem 1rem;\r\n        text-align: center;\r\n        color: #6b7280;\r\n        font-style: italic;\r\n        font-size: 0.875rem;\r\n      }\r\n\r\n\r\n      .loading-state {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        gap: 0.5rem;\r\n\r\n\r\n        &::before {\r\n          content: '';\r\n          width: 16px;\r\n          height: 16px;\r\n          border: 2px solid #e5e7eb;\r\n          border-top: 2px solid #3b82f6;\r\n          border-radius: 50%;\r\n          animation: spin 1s linear infinite;\r\n        }\r\n      }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Form Actions - Match ExpenseForm\r\n.notes-actions {\r\n  display: flex;\r\n  justify-content: end;\r\n  gap: 1rem;\r\n  padding-top: 1rem;\r\n  border-top: 1px solid #e5e7eb;\r\n\r\n\r\n  @media (max-width: 768px) {\r\n    flex-direction: column;\r\n  }\r\n\r\n\r\n  .notes-btn {\r\n    padding: 0.75rem 1.5rem;\r\n    border: none;\r\n    border-radius: 0.375rem;\r\n    font-weight: 500;\r\n    font-size: 0.875rem;\r\n    cursor: pointer;\r\n    min-width: 120px;\r\n    transition: all 0.2s ease;\r\n\r\n\r\n    @media (max-width: 768px) {\r\n      width: 100%;\r\n    }\r\n\r\n\r\n    &.notes-btn-save {\r\n      background-color: var(--primary-color);\r\n      color: white;\r\n\r\n\r\n      &:focus {\r\n        outline: none;\r\n      }\r\n      &:hover{\r\n        background-color: #005a9a;\r\n      }\r\n\r\n\r\n      &:disabled {\r\n        background-color: #d1d5db;\r\n        color: #9ca3af;\r\n        cursor: not-allowed;\r\n        opacity: 0.6;\r\n      }\r\n    }\r\n   \r\n  }\r\n  .notes-btn-cancel {\r\n      padding: 8px 16px;\r\n      border: 1px solid #ddd;\r\n      background: white;\r\n      color: #666;\r\n      border-radius: 4px;\r\n      cursor: pointer;\r\n      font-size: 14px;\r\n\r\n\r\n      &:hover {\r\n        background-color: #f8f9fa;\r\n      }\r\n    }\r\n\r\n\r\n}\r\n\r\n\r\n// Animations\r\n@keyframes notes-form-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n\r\n@keyframes dropdown-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-4px);\r\n  }\r\n\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n\r\n// Scrollbar styling for dropdown\r\n.dropdown-options::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n\r\n.dropdown-options::-webkit-scrollbar-track {\r\n  background: #f1f5f9;\r\n  border-radius: 3px;\r\n}\r\n\r\n\r\n.dropdown-options::-webkit-scrollbar-thumb {\r\n  background: #cbd5e1;\r\n  border-radius: 3px;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n\r\n.dropdown-options::-webkit-scrollbar-thumb:hover {\r\n  background: #94a3b8;\r\n}\r\n\r\n\r\n// Responsive design improvements\r\n@media (max-width: 768px) {\r\n  .notes-form {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n\r\n@media (max-width: 480px) {\r\n  .notes-container {\r\n    padding: 0.5rem;\r\n  }\r\n\r\n\r\n  .notes-form-wrapper {\r\n    padding: 0.75rem;\r\n  }\r\n\r\n\r\n  .notes-title {\r\n    font-size: 1.125rem;\r\n  }\r\n\r\n\r\n  .notes-form-group {\r\n    .notes-input,\r\n    .notes-textarea,\r\n    .custom-dropdown-input {\r\n      padding: 0.375rem;\r\n      font-size: 0.8125rem;\r\n    }\r\n  }\r\n\r\n\r\n  .notes-actions {\r\n    .notes-btn {\r\n      padding: 0.5rem 1rem;\r\n      font-size: 0.8125rem;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Print styles\r\n@media print {\r\n  .notes-container {\r\n    background: white;\r\n    padding: 0;\r\n  }\r\n\r\n\r\n  .notes-form-wrapper {\r\n    box-shadow: none;\r\n    border: 1px solid #000;\r\n  }\r\n\r\n\r\n  .notes-actions,\r\n  .dropdown-content {\r\n    display: none;\r\n  }\r\n\r\n\r\n  .note-form-close-button {\r\n    display: none;\r\n  }\r\n}\r\n\r\n\r\n// Focus visible improvements for accessibility\r\n// input:focus-visible,\r\n// select:focus-visible,\r\n// button:focus-visible,\r\n// textarea:focus-visible {\r\n//   outline: 2px solid #3b82f6;\r\n//   outline-offset: 2px;\r\n// }\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
